"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertiesApi = void 0;
const handlers_1 = require("../handlers");
const accounts_1 = require("./accounts");
const amenities_1 = require("./amenities");
const bathrooms_1 = require("./bathrooms");
const beds_1 = require("./beds");
const local_licence_1 = require("./local_licence");
const restrictions_1 = require("./restrictions");
exports.propertiesApi = (http, prefix = '/client/property') => ({
    accounts: accounts_1.accountsApi(http),
    beds: beds_1.bedsApi(http),
    bathrooms: bathrooms_1.bathroomsApi(http),
    amenities: amenities_1.amenitiesApi(http),
    restrictions: restrictions_1.restrictionsApi(http),
    local_licence: local_licence_1.localLicenceApi(http),
    getById(id) {
        return http.get(`${prefix}/${id}`);
    },
    getAllForOwner(ownerId) {
        return http.get(`${prefix}/owner/${ownerId}`).catch(handlers_1._404([]));
    },
    create(property) {
        return http.post(`${prefix}`, property);
    },
    update(property) {
        return http.put(`${prefix}/${property.id}`, property);
    },
    deleteSubdocuments(propertyId, subdocuments) {
        return http.put(`${prefix}/${propertyId}/delete-subdocuments`, subdocuments);
    },
    publish(id) {
        return http.put(`${prefix}/${id}/publish`);
    },
    getItemTypes() {
        return http.get('/properties/item_types');
    },
    search(query, version = 'published') {
        return http.get(`/properties/search?q=${query}&v=${version}`);
    },
    activate(id) {
        return http.put(`/properties/${id}/activate`);
    },
    deactivate(id) {
        return http.put(`/properties/${id}/deactivate`);
    }
});
//# sourceMappingURL=index.js.map